import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingConstants = function () { return utilBalancing.getBalancing().Constants; };
export var selectBalancingCoopDescriptionCharAmount = memoize(function () { return selectBalancingConstants().coopDescCharAmount; });
export var selectBalancingCoopNewsCharAmount = memoize(function () { return selectBalancingConstants().coopNewsCharAmount; });
export var selectBalancingCoopUnlockLevel = memoize(function () { return selectBalancingConstants().coopUnlockLevel; });
export var selectBalancingMarketUnlockLevel = memoize(function () { return selectBalancingConstants().marketUnlockLevel; });
export var selectBalancingSkipTrashingFactor = memoize(function () { return selectBalancingConstants().skipTrashingFactor; });
export var selectBalancingSkipConstructionFactor = memoize(function () { return selectBalancingConstants().skipConstructionFactor; });
export var selectBalancingSkipProductionFactor = memoize(function () { return selectBalancingConstants().skipProductionFactor; });
export var selectBalancingCollectLeagueUnlockLevel = memoize(function () { return selectBalancingConstants().collectingLeagueUnlockLevel; });
export var balancingConstantsMemoizedFunctions = [
    selectBalancingConstants,
    selectBalancingCoopDescriptionCharAmount,
    selectBalancingCoopUnlockLevel,
    selectBalancingMarketUnlockLevel,
    selectBalancingSkipTrashingFactor,
    selectBalancingSkipConstructionFactor,
    selectBalancingSkipProductionFactor,
    selectBalancingCollectLeagueUnlockLevel,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingConstants.ts
// module id = 87
// module chunks = 3